import svgPaths from "./svg-n37i3z40qb";
import imgImageWithFallback from "figma:asset/a2a249bb9ed5e2c71ebce71f7d764de78345f3dc.png";
import imgImageWithFallback1 from "figma:asset/71f8768a9af6196b4aac73f4f7c6da51d58df84e.png";
import imgImageWithFallback2 from "figma:asset/a79de8ff1ec6937fc6210d55bf90e0a5bbec2e0c.png";
import imgImageWithFallback3 from "figma:asset/d91e9770a4c324c63663f88b48ec48de271f24d9.png";
import imgImageWithFallback4 from "figma:asset/1a074ef53129c0e3e170c93d120a62b957bba0fc.png";
import { imgGroup } from "./svg-nfig8";

// Re-export images for use in other components
export const imgStreet = imgImageWithFallback;
export const imgPortrait = imgImageWithFallback1;
export const imgArchitecture = imgImageWithFallback2;
export const imgBlackWhite = imgImageWithFallback3;
export const imgNature = imgImageWithFallback4;

function Collections1() {
  return (
    <div className="h-[66px] relative shrink-0 w-full" data-name="Collections">
      <p className="-translate-x-1/2 absolute font-['Playfair_Display:Regular',sans-serif] font-normal leading-[66px] left-[553.83px] text-[44px] text-center text-white top-[0.33px] tracking-[0.5px] whitespace-nowrap">Collections</p>
    </div>
  );
}

function Collections2() {
  return (
    <div className="h-[20.667px] relative shrink-0 w-full" data-name="Collections">
      <p className="-translate-x-1/2 absolute font-['Inter:Light',sans-serif] font-light leading-[21px] left-[554.05px] not-italic text-[14px] text-[rgba(255,255,255,0.5)] text-center top-0 tracking-[0.6px] whitespace-nowrap">Browse by category</p>
    </div>
  );
}

function Container() {
  return (
    <div className="content-stretch flex flex-col gap-[10px] h-[96.667px] items-start relative shrink-0 w-full" data-name="Container">
      <Collections1 />
      <Collections2 />
    </div>
  );
}

function ImageWithFallback() {
  return (
    <div className="absolute left-0 size-[552.5px] top-0" data-name="ImageWithFallback">
      <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgImageWithFallback} />
    </div>
  );
}

function Collections3() {
  return <div className="absolute bg-gradient-to-t from-[rgba(0,0,0,0.65)] left-0 size-[552.5px] to-[rgba(0,0,0,0.1)] top-0 via-[40%] via-[rgba(0,0,0,0.25)]" data-name="Collections" />;
}

function Collections4() {
  return <div className="absolute bg-[#f4c430] h-[2px] left-0 top-[550.5px] w-0" data-name="Collections" />;
}

function Collections5() {
  return (
    <div className="absolute h-[27.333px] left-[16px] top-[509.17px] w-[520.5px]" data-name="Collections">
      <p className="absolute font-['Playfair_Display:Regular',sans-serif] font-normal leading-[27.5px] left-0 text-[22px] text-white top-[-0.33px] tracking-[0.3px] whitespace-nowrap">Street Photography</p>
    </div>
  );
}

function Container2() {
  return (
    <div className="absolute left-0 overflow-clip size-[552.5px] top-0" data-name="Container">
      <ImageWithFallback />
      <Collections3 />
      <Collections4 />
      <Collections5 />
    </div>
  );
}

function ImageWithFallback1() {
  return (
    <div className="absolute left-0 size-[552.5px] top-0" data-name="ImageWithFallback">
      <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgImageWithFallback1} />
    </div>
  );
}

function Collections6() {
  return <div className="absolute bg-gradient-to-t from-[rgba(0,0,0,0.65)] left-0 size-[552.5px] to-[rgba(0,0,0,0.1)] top-0 via-[40%] via-[rgba(0,0,0,0.25)]" data-name="Collections" />;
}

function Collections7() {
  return <div className="absolute bg-[#f4c430] h-[2px] left-0 top-[550.5px] w-0" data-name="Collections" />;
}

function Collections8() {
  return (
    <div className="absolute h-[27.333px] left-[16px] top-[509.17px] w-[520.5px]" data-name="Collections">
      <p className="absolute font-['Playfair_Display:Regular',sans-serif] font-normal leading-[27.5px] left-0 text-[22px] text-white top-[-0.33px] tracking-[0.3px] whitespace-nowrap">{`Portrait & People`}</p>
    </div>
  );
}

function Container3() {
  return (
    <div className="absolute left-[555.5px] overflow-clip size-[552.5px] top-0" data-name="Container">
      <ImageWithFallback1 />
      <Collections6 />
      <Collections7 />
      <Collections8 />
    </div>
  );
}

function ImageWithFallback2() {
  return (
    <div className="absolute left-0 size-[552.5px] top-0" data-name="ImageWithFallback">
      <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgImageWithFallback2} />
    </div>
  );
}

function Collections9() {
  return <div className="absolute bg-gradient-to-t from-[rgba(0,0,0,0.65)] left-0 size-[552.5px] to-[rgba(0,0,0,0.1)] top-0 via-[40%] via-[rgba(0,0,0,0.25)]" data-name="Collections" />;
}

function Collections10() {
  return <div className="absolute bg-[#f4c430] h-[2px] left-0 top-[550.5px] w-0" data-name="Collections" />;
}

function Collections11() {
  return (
    <div className="absolute h-[27.333px] left-[16px] top-[509.17px] w-[520.5px]" data-name="Collections">
      <p className="absolute font-['Playfair_Display:Regular',sans-serif] font-normal leading-[27.5px] left-0 text-[22px] text-white top-[-0.33px] tracking-[0.3px] whitespace-nowrap">Architecture</p>
    </div>
  );
}

function Container4() {
  return (
    <div className="absolute left-0 overflow-clip size-[552.5px] top-[555.5px]" data-name="Container">
      <ImageWithFallback2 />
      <Collections9 />
      <Collections10 />
      <Collections11 />
    </div>
  );
}

function ImageWithFallback3() {
  return (
    <div className="absolute left-0 size-[552.5px] top-0" data-name="ImageWithFallback">
      <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgImageWithFallback3} />
    </div>
  );
}

function Collections12() {
  return <div className="absolute bg-gradient-to-t from-[rgba(0,0,0,0.65)] left-0 size-[552.5px] to-[rgba(0,0,0,0.1)] top-0 via-[40%] via-[rgba(0,0,0,0.25)]" data-name="Collections" />;
}

function Collections13() {
  return <div className="absolute bg-[#f4c430] h-[2px] left-0 top-[550.5px] w-0" data-name="Collections" />;
}

function Collections14() {
  return (
    <div className="absolute h-[27.333px] left-[16px] top-[509.17px] w-[520.5px]" data-name="Collections">
      <p className="absolute font-['Playfair_Display:Regular',sans-serif] font-normal leading-[27.5px] left-0 text-[22px] text-white top-[-0.33px] tracking-[0.3px] whitespace-nowrap">{`Black & White`}</p>
    </div>
  );
}

function Container5() {
  return (
    <div className="absolute left-[555.5px] overflow-clip size-[552.5px] top-[555.5px]" data-name="Container">
      <ImageWithFallback3 />
      <Collections12 />
      <Collections13 />
      <Collections14 />
    </div>
  );
}

function ImageWithFallback4() {
  return (
    <div className="absolute left-0 size-[552.5px] top-0" data-name="ImageWithFallback">
      <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgImageWithFallback4} />
    </div>
  );
}

function Collections15() {
  return <div className="absolute bg-gradient-to-t from-[rgba(0,0,0,0.65)] left-0 size-[552.5px] to-[rgba(0,0,0,0.1)] top-0 via-[40%] via-[rgba(0,0,0,0.25)]" data-name="Collections" />;
}

function Collections16() {
  return <div className="absolute bg-[#f4c430] h-[2px] left-0 top-[550.5px] w-0" data-name="Collections" />;
}

function Collections17() {
  return (
    <div className="absolute h-[27.333px] left-[16px] top-[509.17px] w-[520.5px]" data-name="Collections">
      <p className="absolute font-['Playfair_Display:Regular',sans-serif] font-normal leading-[27.5px] left-0 text-[22px] text-white top-[-0.33px] tracking-[0.3px] whitespace-nowrap">{`Nature & Landscape`}</p>
    </div>
  );
}

function Container6() {
  return (
    <div className="absolute left-0 overflow-clip size-[552.5px] top-[1111px]" data-name="Container">
      <ImageWithFallback4 />
      <Collections15 />
      <Collections16 />
      <Collections17 />
    </div>
  );
}

function Container1() {
  return (
    <div className="h-[1663.5px] relative shrink-0 w-full" data-name="Container">
      <Container2 />
      <Container3 />
      <Container4 />
      <Container5 />
      <Container6 />
    </div>
  );
}

function Collections() {
  return (
    <div className="bg-black h-[2006.167px] relative shrink-0 w-full" data-name="Collections">
      <div className="content-stretch flex flex-col gap-[40px] items-start pt-[110px] px-[16px] relative size-full">
        <Container />
        <Container1 />
      </div>
    </div>
  );
}

function Paragraph() {
  return (
    <div className="absolute h-[24px] left-[202px] top-[64px] w-[736px]" data-name="Paragraph">
      <p className="-translate-x-1/2 absolute font-['Playfair_Display:Regular',sans-serif] font-normal leading-[24px] left-[367.62px] text-[16px] text-center text-white top-[-0.67px] tracking-[1.6px] whitespace-nowrap">[NAFN]</p>
    </div>
  );
}

function Paragraph1() {
  return (
    <div className="absolute h-[52px] left-[214px] top-[112px] w-[712px]" data-name="Paragraph">
      <p className="-translate-x-1/2 absolute font-['Inter:Regular',sans-serif] font-normal leading-[26px] left-[356.22px] not-italic text-[#a1a1a1] text-[16px] text-center top-[-0.67px] tracking-[0.4px] w-[666px]">Beautiful limited edition photographic prints. Each image comes with a certificate of authenticity and edition number.</p>
    </div>
  );
}

function Paragraph2() {
  return (
    <div className="absolute h-[20px] left-[202px] top-[196px] w-[736px]" data-name="Paragraph">
      <p className="-translate-x-1/2 absolute font-['Inter:Italic',sans-serif] font-normal italic leading-[20px] left-[367.89px] text-[#737373] text-[14px] text-center top-[0.33px] tracking-[0.35px] whitespace-nowrap">In memory of my friend Þorleifur</p>
    </div>
  );
}

function Group() {
  return (
    <div className="absolute inset-[8.33%] mask-alpha mask-intersect mask-no-clip mask-no-repeat mask-position-[-1.5px_-1.5px] mask-size-[18px_18px]" data-name="Group" style={{ maskImage: `url('${imgGroup}')` }}>
      <div className="absolute inset-[-5%]">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 16.5 16.5">
          <g id="Group">
            <path d={svgPaths.pef8c000} id="Vector" stroke="var(--stroke-0, #F4C430)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            <path d={svgPaths.p39aec572} id="Vector_2" stroke="var(--stroke-0, #F4C430)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            <path d="M12.375 4.125H12.3825" id="Vector_3" stroke="var(--stroke-0, #F4C430)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
          </g>
        </svg>
      </div>
    </div>
  );
}

function ClipPathGroup() {
  return (
    <div className="absolute contents inset-0" data-name="Clip path group">
      <Group />
    </div>
  );
}

function Icon() {
  return (
    <div className="relative shrink-0 size-[18px]" data-name="Icon">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid overflow-clip relative rounded-[inherit] size-full">
        <ClipPathGroup />
      </div>
    </div>
  );
}

function Link() {
  return (
    <div className="flex-[1_0_0] h-[20px] min-h-px min-w-px relative" data-name="Link">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[20px] left-0 not-italic text-[#f4c430] text-[14px] top-[0.33px] tracking-[0.35px] whitespace-nowrap">@nafn</p>
      </div>
    </div>
  );
}

function Container8() {
  return (
    <div className="h-[20px] relative shrink-0 w-[70.865px]" data-name="Container">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex gap-[8px] items-center relative size-full">
        <Icon />
        <Link />
      </div>
    </div>
  );
}

function Paragraph3() {
  return (
    <div className="flex-[1_0_0] min-h-px min-w-px relative w-[55.156px]" data-name="Paragraph">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
        <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[20px] left-0 not-italic text-[#737373] text-[14px] top-[0.33px] tracking-[0.7px] whitespace-nowrap">© 2025</p>
      </div>
    </div>
  );
}

function Container7() {
  return (
    <div className="absolute content-stretch flex flex-col gap-[16px] h-[56px] items-center left-[202px] top-[248px] w-[736px]" data-name="Container">
      <Container8 />
      <Paragraph3 />
    </div>
  );
}

function Container10() {
  return (
    <div className="h-[24px] relative shrink-0 w-full" data-name="Container">
      <p className="-translate-x-1/2 absolute font-['Inter:Regular',sans-serif] font-normal leading-[16.5px] left-[368.69px] not-italic text-[11px] text-[rgba(255,255,255,0.08)] text-center top-[4.33px] tracking-[0.5px] whitespace-nowrap">Admin</p>
    </div>
  );
}

function Container9() {
  return (
    <div className="absolute content-stretch flex flex-col h-[74px] items-start left-[202px] pt-[50px] top-[352px] w-[736px]" data-name="Container">
      <div aria-hidden="true" className="absolute border-[#262626] border-solid border-t inset-0 pointer-events-none" />
      <Container10 />
    </div>
  );
}

function Footer() {
  return (
    <div className="bg-black h-[482px] relative shrink-0 w-full" data-name="Footer">
      <Paragraph />
      <Paragraph1 />
      <Paragraph2 />
      <Container7 />
      <Container9 />
    </div>
  );
}

function Layout() {
  return (
    <div className="bg-black content-stretch flex flex-col gap-[96px] h-[2694.167px] items-start pt-[110px] relative shrink-0 w-full" data-name="Layout">
      <Collections />
      <Footer />
    </div>
  );
}

function Body() {
  return (
    <div className="absolute bg-white content-stretch flex flex-col h-[606.667px] items-start left-0 top-0 w-[1140px]" data-name="Body">
      <Layout />
    </div>
  );
}

function SignatureLogo() {
  return (
    <div className="h-[47.365px] relative shrink-0 w-[48px]" data-name="SignatureLogo">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 48 47.3646">
        <g clipPath="url(#clip0_1162_107)" id="SignatureLogo">
          <path d={svgPaths.p1d917e00} fill="var(--fill-0, white)" id="Vector" />
        </g>
        <defs>
          <clipPath id="clip0_1162_107">
            <rect fill="white" height="47.3646" width="48" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

function Link1() {
  return (
    <div className="relative shrink-0 size-[64px]" data-name="Link">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex items-center justify-center px-[8px] relative size-full">
        <SignatureLogo />
      </div>
    </div>
  );
}

function Icon1() {
  return (
    <div className="relative shrink-0 size-[40px]" data-name="Icon">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 40 40">
        <g id="Icon">
          <path d="M5 10H35" id="Vector" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeWidth="2.67" />
          <path d="M5 20H35" id="Vector_2" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeWidth="2.67" />
          <path d="M5 30H35" id="Vector_3" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeWidth="2.67" />
        </g>
      </svg>
    </div>
  );
}

function Button() {
  return (
    <div className="flex-[1_0_0] h-[40px] min-h-px min-w-px relative" data-name="Button">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex items-center justify-center relative size-full">
        <Icon1 />
      </div>
    </div>
  );
}

function Container11() {
  return (
    <div className="relative shrink-0 size-[40px]" data-name="Container">
      <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex items-center relative size-full">
        <Button />
      </div>
    </div>
  );
}

function Layout1() {
  return (
    <div className="absolute content-stretch flex h-[110px] items-center justify-between left-0 px-[16px] top-0 w-[1140px]" data-name="Layout">
      <Link1 />
      <Container11 />
    </div>
  );
}

export default function SetjaUppSiduEinsOgKeyiscreation() {
  return (
    <div className="bg-white relative size-full" data-name="Setja upp síðu eins og keyiscreation">
      <Body />
      <Layout1 />
    </div>
  );
}